export default {
  name: 'AudioJungle',
  abbreviation: 'AJ',
  domain: 'audiojungle.net',
  google_analytics_id: 'UA-11834194-4',
  google_remarketing_label: 'SQ7NCLWBugMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'eg. ambient music',
  assets_domains: {
    item_thumbnail: 'thumb-aj.s3.envato.com',
    item_image: 'image-aj.s3.envato.com'
  },
  feeds_categories: [
    '/category/music',
    '/category/music-packs',
    '/category/music-kits',
    '/category/sound',
    '/category/source-files',
    '/category/logos-idents'
  ]
}



// WEBPACK FOOTER //
// ./config/sites/audiojungle.js